export const PAGE_SIZE = 15;

export const TABLE_PAGE_SIZE = 12;

export const ALL_ROLES = {
  instructor: 'instructor',
  courseCreator: 'course-creator',
  owner: 'owner',
  admin: 'admin',
};

export const REQUIRED_TEXT_MESSAGE = 'این فیلد اجباری است';
export const NO_DIFF_TEXT = 'بدون تغییر در فرم اطلاعات ارسال نخواهد شد.';
